import React from 'react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import MCancellation from './FormTypes/m_cancellation'
import MContactForm from './FormTypes/m_contactform'
import DeleteJourneyForm from './FormTypes/m_delete_journey_form'
import MCupOfFansGroupRegistration from './FormTypes/m_cup_of_fans_group_registration'
import MCupOfFansRegistration from './FormTypes/m_cup_of_fans_registration'
import MDfbReferee from './FormTypes/m_dfb_referee'
import MFairPlayMedaille from './FormTypes/m_fair_play_medaille'
import MFanConcerns from './FormTypes/m_fan_concerns'
import MFanMatchRegistration from './FormTypes/m_fan_match_registration'
import MJuliusHirschPreis from './FormTypes/m_julius_hirsch_preis'
import MPressApplication from './FormTypes/m_press_application'
import MSoccerHeroes from './FormTypes/m_soccer_heroes'
import MVolunteerAward from './FormTypes/m_volunteer_award'
import MSuggestTopic from './FormTypes/m_suggest_topic'
import MSalesRequestForm from './FormTypes/m_sales_request_form'
import MHospitalityForm from './FormTypes/m_hospitality_form'
import MCupOfFansFanclubRegistration from './FormTypes/m_cup_of_fans_fanclub_registration'

const MForm = ({ data }) => {
  const identifier = data.form_definition?.[0]?.identifier
  if (!identifier) {
    return null
  }

  const renderForm = (identifier, data) => {
    switch (identifier) {
      case 'Kontaktformular':
        return <MContactForm data={data} />
      case 'DFBSchiedsrichterzeitung':
        return <MDfbReferee data={data} />
      case 'FairPlayMedaille':
        return <MFairPlayMedaille data={data} />
      case 'DFB-Fan-Club-Reise löschen':
        return <DeleteJourneyForm data={data} />
      case 'JuliusHirschPreis':
        return <MJuliusHirschPreis data={data} />
      case 'FanMatchAnmeldung':
        return <MFanMatchRegistration data={data} />
      case 'CupDerFansEinzelanmeldung':
        return <MCupOfFansRegistration data={data} />
      case 'CupDerFansGruppenanmeldung':
        return <MCupOfFansGroupRegistration data={data} />
      case 'CupDerFansFanclubanmeldung':
        return <MCupOfFansFanclubRegistration data={data} />
      case 'Fanbelange':
        return <MFanConcerns data={data} />
      case 'Fussballhelden':
        return <MSoccerHeroes data={data} />
      case 'Ehrenamtspreis':
        return <MVolunteerAward data={data} />
      case 'FanclubWiderruf':
        return <MCancellation data={data} />
      case 'Presseantrag':
        return <MPressApplication data={data} />
      case 'ThemaVorschlagen':
        return <MSuggestTopic data={data} />
      case 'SalesRequest':
        return <MSalesRequestForm data={data} />
      case 'HospitalityFormular':
        return <MHospitalityForm data={data} />
      default:
        return `Form '${identifier}' not found`
    }
  }

  return (
    <Section baseClass="m-Formblock" data={data} defaultPadding="small">
      <div className="m-Formblock-wrapper">
        <div className="m-Formblock-container">{renderForm(identifier, data)}</div>
      </div>
    </Section>
  )
}

export default MForm
